const generateData = (rows, query) => {
  const newData = rows?.rows.map((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    invoiceId: row.cols[0], // 1349 شناسه فاکتور
    issueDate: row.cols[1], // تاریخ صدور
    issueTime: row.cols[2], // زمان صدور
    refrenceId: row.cols[3], // شناسه ارجاع
    tax: row.cols[4], // مالیات
    amountPayable: row.cols[5], // مبلغ قابل پرداخت
    dateOfPayment: row.cols[6], // تاریخ پرداخت
    timeOfPayment: row.cols[7], // زمان پرداخت
    invoiceStatus: row.cols[8], // وضعیت فاکتور
    businessName: row.cols[9], // نام کسب‌وکار
    paymentType: row.cols[10], // نوع پرداخت
  }));

  return newData;
};

export default generateData;




